export const languageCodeNameMapping = {
  'zh-CN': '中文',
  'en-US': 'English',
  'id-ID': 'Bahasa Indonesia',
  'vi-VN': 'Tiếng Việt',
  'ru-RU': 'Pусский',
};

export function getDisplayName(languageCode) {
  if (! languageCode) return '';
  return languageCodeNameMapping[languageCode];
}

const Languages = {
  getDisplayName,
  mapping: languageCodeNameMapping,
  defaultLanguageCode: 'en-US',
};

export default Languages;



// WEBPACK FOOTER //
// ./domain/Languages/index.js